import axiosInstance from "./AxiosInstance";

export function getTodayBillibgDashboardApi(serviceCenterId){
    return axiosInstance.get(`api/summary-today/${serviceCenterId}`)
}

export function getThisMonthExpenseDashboardApi(serviceCenterId){
    return axiosInstance.get(`api/summary-expenses/${serviceCenterId}`)
}

export function getThisMonthBillingDashboardApi(serviceCenterId){
    return axiosInstance.get(`api/summary-revenue/${serviceCenterId}`)
}

export function getThisMonthVehicleTypeDashboardApi(serviceCenterId){
    return axiosInstance.get(`api/summary-vehicle-types/${serviceCenterId}`)
}
export function getRevenueLossDashboardApi(serviceCenterId,year){
    return axiosInstance.get(`api/yearly-financial-summary/${serviceCenterId}?year=${year}`)
}
export function getPaymentMethodDashboardApi(serviceCenterId,param){
    const fparam=new URLSearchParams(param).toString()
    return axiosInstance.get(`api/billing-payment-details/${serviceCenterId}?${fparam}`)
}
export function getTimeChartDashboardApi(serviceCenterId,param){
    const fparam=new URLSearchParams(param).toString()
    return axiosInstance.get(`api/billing-time-intervals/${serviceCenterId}?${fparam}`)
}
export function getServiceTypeDashboardApi(serviceCenterId,param){
    const fparam=new URLSearchParams(param).toString()
    return axiosInstance.get(`api/billing-service-types/${serviceCenterId}?${fparam}`)
}
export function getCashDashboardApi(serviceCenterId){
    return axiosInstance.get(`api/cash-summary/${serviceCenterId}`)
}
export function getNotificationApi(){
    return axiosInstance.get('api/cash-flows/approval/')
}
export function gettActionNotification(id,data){
    return axiosInstance.post(`api/cash-flows/${id}/approval/`,data)
}
//user dashboard
export function getUserTodayBillibgDashboardApi(){
    return axiosInstance.get('api/user/summary-today/')
}

export function getUserThisMonthExpenseDashboardApi(){
    return axiosInstance.get('api/user/summary-expenses/')
}

export function getUserThisMonthBillingDashboardApi(){
    return axiosInstance.get('api/user/summary-revenue/')
}

export function getUserThisMonthVehicleTypeDashboardApi(){
    return axiosInstance.get('api/user/summary-vehicle-types/')
}
export function getWhatsAppReportDashboardApi(date){
    return axiosInstance.get(`api/daily-whatsapp-report?date=${date}`)
}
export function getUserTimeChartDashboardApi(param){
    const fparam=new URLSearchParams(param).toString()
    return axiosInstance.get(`api/billing-time-intervals/?${fparam}`)
}
export function getUserServiceTypeDashboardApi(param){
    const fparam=new URLSearchParams(param).toString()
    return axiosInstance.get(`api/billing-service-types/?${fparam}`)
}